/* =========================================================
   Add-to-cart celebration burst (theme v1.6)
   Loaded with the cart drawer (product, collection and search pages).
   cc-product.js and cc-plp.js call window.ccCelebrate(button)
   ONLY after the item was added to the cart.

   After the cart drawer has opened and settled (plus a short beat),
   a single emitter ~55px above the drawer's "Proceed to Checkout"
   button fires a 360-degree confetti pop: ~200 small paper strips,
   squares and dots in random bright colours. Pieces pop outward
   fast, slow down sharply (air drag), drift, then fall slowly under
   gravity for roughly 7 seconds across the drawer and the page.

   One temporary full-screen <canvas> above everything, with
   pointer-events:none so it never blocks any click or tap. It is
   removed as soon as the last piece has fallen off-screen.
   Skipped entirely when prefers-reduced-motion is set.
   ========================================================= */
(function () {
  'use strict';

  var MOBILE_MAX = 749;          // theme mobile breakpoint
  var Z_TOP = 2147483647;        // above the cart drawer (2147483600)
  var SETTLE_FALLBACK = 480;     // ms; max wait for the drawer slide to finish before the burst
  var OPEN_WAIT_MAX = 900;       // ms to wait for the drawer to open
  var BEAT = 400;                // ms pause after the drawer settles
  var COUNT = 200;               // pieces per burst
  var MAX_SPEED = 1125;          // px/s initial speed (fastest pieces)
  var DRAG = 1.5;                // 1/s exponential air drag
  var GRAVITY = 210;             // px/s^2  (slow ~140px/s terminal fall)
  var DOWN_DAMP = 0.5;           // downward-heading pieces launch up to 50% slower
  var LIFT = 60;                 // px/s upward lift at launch (cloud drifts up first)
  var ABOVE_CHECKOUT = 55;       // px above the Checkout button's top edge
  var SAFETY_MS = 12000;         // hard backstop for cleanup (normal end is ~7s)

  var canvas = null, ctx = null, particles = [], rafId = 0, lastT = 0, safetyTimer = 0, W = 0, H = 0;

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function drawerRoot() { return document.querySelector('[data-cc-cart-drawer]'); }
  function drawerOpen() { var r = drawerRoot(); return !!(r && r.classList.contains('is-open')); }

  function teardown() {
    if (rafId) cancelAnimationFrame(rafId);
    clearTimeout(safetyTimer);
    rafId = 0; particles = []; ctx = null;
    if (canvas && canvas.parentNode) canvas.parentNode.removeChild(canvas);
    canvas = null;
  }

  function ensureCanvas() {
    if (canvas) return;
    W = window.innerWidth; H = window.innerHeight;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas = document.createElement('canvas');
    canvas.className = 'cc-celebrate-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    canvas.setAttribute('role', 'presentation');
    canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;margin:0;padding:0;border:0;background:transparent;';
    canvas.style.zIndex = String(Z_TOP);
    document.body.appendChild(canvas);
    canvas.width = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx._dpr = dpr;
  }

  function spawn(x, y) {
    for (var i = 0; i < COUNT; i++) {
      var angle = Math.random() * Math.PI * 2;                    // full 360 degrees
      var speed = MAX_SPEED * (0.12 + 0.88 * Math.sqrt(Math.random()));
      var sn = Math.sin(angle);
      if (sn > 0) speed *= 1 - DOWN_DAMP * sn;                    // fewer pieces shoot straight down
      var r = Math.random();
      var kind = r < 0.7 ? 'strip' : (r < 0.85 ? 'square' : 'dot');
      var w, h;
      if (kind === 'strip') { w = 1.6 + Math.random() * 0.9; h = 6 + Math.random() * 2.5; }
      else { w = h = 2.8 + Math.random() * 1.4; }
      particles.push({
        x: x, y: y,
        vx: Math.cos(angle) * speed,
        vy: sn * speed - LIFT,
        rot: Math.random() * Math.PI * 2,
        vr: (Math.random() * 2 - 1) * 9,                          // spin, rad/s
        w: w, h: h, kind: kind,
        color: 'hsl(' + Math.floor(Math.random() * 360) + ',100%,' + (64 + Math.floor(Math.random() * 10)) + '%)'
      });
    }
  }

  function frame(t) {
    if (!ctx) return;
    var dt = Math.min((t - lastT) / 1000, 0.05);
    lastT = t;
    var dpr = ctx._dpr || 1;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, W, H);
    var damp = Math.exp(-DRAG * dt);
    var alive = [];
    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      p.vx *= damp;
      p.vy = p.vy * damp + GRAVITY * dt;
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.rot += p.vr * dt;
      if (p.y > H + 12) continue;                                  // fell off the bottom: done
      alive.push(p);
      if (p.x < -12 || p.x > W + 12 || p.y < -12) continue;       // off-screen for now: keep, don't draw
      var c = Math.cos(p.rot), s = Math.sin(p.rot);
      ctx.setTransform(c * dpr, s * dpr, -s * dpr, c * dpr, p.x * dpr, p.y * dpr);
      ctx.fillStyle = p.color;
      if (p.kind === 'dot') {
        ctx.beginPath();
        ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
        ctx.fill();
      } else {
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      }
    }
    particles = alive;
    if (particles.length) rafId = requestAnimationFrame(frame);
    else teardown();
  }

  /* Wait for the drawer to open and finish sliding in. done(true|false). */
  function whenDrawerSettled(done) {
    var t0 = Date.now();
    (function waitOpen() {
      if (drawerOpen()) {
        var panel = drawerRoot().querySelector('[data-cc-cart-drawer-panel]');
        var finished = false, timer = 0;
        var finish = function () {
          if (finished) return;
          finished = true;
          clearTimeout(timer);
          if (panel) panel.removeEventListener('transitionend', onEnd);
          done(true);
        };
        var onEnd = function (e) { if (e.target === panel && e.propertyName === 'transform') finish(); };
        if (panel) panel.addEventListener('transitionend', onEnd);
        timer = setTimeout(finish, SETTLE_FALLBACK);
        return;
      }
      if (Date.now() - t0 > OPEN_WAIT_MAX) { done(false); return; }
      setTimeout(waitOpen, 30);
    })();
  }

  function fire() {
    if (!drawerOpen()) return;                                     // drawer closed during the beat: skip
    var root = drawerRoot();
    var btn = root.querySelector('[data-cc-cart-checkout]');
    var panel = root.querySelector('[data-cc-cart-drawer-panel]');
    if (!btn || !panel) return;
    var b = btn.getBoundingClientRect(), p = panel.getBoundingClientRect();
    if (!b.width || !p.width) return;
    var mobile = window.innerWidth <= MOBILE_MAX;
    var x = p.left + p.width * (mobile ? 0.32 : 0.44);             // slightly left of drawer centre
    var y = b.top - ABOVE_CHECKOUT;
    ensureCanvas();
    spawn(x, y);
    if (!rafId) {
      lastT = performance.now();
      rafId = requestAnimationFrame(frame);
    }
    clearTimeout(safetyTimer);
    safetyTimer = setTimeout(teardown, SAFETY_MS);
  }

  function celebrate() {
    try {
      if (reducedMotion()) return;                                  // respect reduced motion
      whenDrawerSettled(function (settled) {
        if (!settled) return;                                       // no drawer: no celebration
        setTimeout(function () {
          try { fire(); } catch (e) { teardown(); }
        }, BEAT);
      });
    } catch (e) {
      teardown();                                                   // never interfere with the cart flow
    }
  }

  window.ccCelebrate = celebrate;
})();
